'use strict';

import controller from './informe.controller';
import template from './informe.html';

const InformeEvaluacion = {
  bindings:{
    proyecto: '=',
    modoVista: '<'
  },
  controller,
  template
};

export default InformeEvaluacion;



// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/informe-eval/informe.component.js